export const CLIENT_EMAIL_CONFIRMATION_MATCH = "/profile/confirm/:token"

export const CLIENT_PROFILE_MATCH = "/profile/edit"
export const CLIENT_SUBSCRIPTIONS_MATCH = "/profile/subscriptions"
export const CLIENT_INVOICES_MATCH = "/profile/invoices"
